var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscussion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M15 9.5v-7c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2v13l4-4h9c1.1 0 2-.9 2-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M18 4.5h-1v8c0 .55-.45 1-1 1H4v1c0 1.1.9 2 2 2h10l4 4v-14c0-1.1-.9-2-2-2"
})));
export { SvgDiscussion as ReactComponent };
export default __webpack_public_path__ + "640e21d9eba4329d488a4710788215eb.svg";